import {
  Infer,
  array,
  boolean,
  defaulted,
  enums,
  nullable,
  object,
  string,
} from "superstruct";
import { ModCfFile } from "types/cf-utils/types";
import { ModCfImage } from "components/Image/types";

export const ModVideoTypes = enums(["local", "youtube"]);

export const ModCfVideo = object({
  __typename: enums(["ContentfulVideoV2"]),
  id: string(),
  contentful_id: string(),
  videoType: defaulted(ModVideoTypes, ""),
  videoLocal: nullable(ModCfFile),
  videoYoutube: nullable(string()),
  previewImage: nullable(array(ModCfImage)),
  openInModal: nullable(boolean()),
  autoplay: nullable(boolean()),
  loop: nullable(boolean()),
  muted: nullable(boolean()),
  customClass: nullable(string()),
});

export type CfVideoProps = Infer<typeof ModCfVideo>;
interface VideoShareProps {
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  previewImage?: string;
}

export interface LocalPlayerProps extends VideoShareProps {
  videoLocal: string;
}

export interface YouTubePlayerProps extends VideoShareProps {
  videoYoutube: string;
}

export type VideoTypes = Infer<typeof ModVideoTypes>;

export interface VideoOtherProps extends VideoShareProps {
  videoLocal: string;
  videoType: VideoTypes | "";
  videoYoutube: string;
}

export interface VideoProps extends VideoOtherProps {
  openInModal: boolean;
}
